import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "there was an idea in this post",
  "description": "",
  "published": "2012-06-09T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4602"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://jaxn.org/article/hang-around-with-people-who-get-shit-done"
      }}>{`http://jaxn.org/article/hang-around-with-people-who-get-shit-done`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      